import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Compass, Home } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const HIDDEN_PATHS = ["/admin", "/auth", "/payment"];

export default function MobileActionBar({ onEnquire }) {
  const { t } = useLang();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const hidden = HIDDEN_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <AnimatePresence>
      {visible && !hidden && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.28, ease: "easeOut" }}
          className="fixed bottom-0 inset-x-0 z-40 sm:hidden"
          data-testid="mobile-action-bar"
        >
          <div
            className="mx-3 mb-3 rounded-full bg-night/95 backdrop-blur-md border border-sand/15 shadow-2xl p-1.5 flex gap-1.5"
            style={{ marginBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
          >
            <Link
              to="/excursions"
              data-testid="mobile-bar-excursions"
              className="flex-1 rounded-full bg-terracotta text-sand py-3 text-sm font-semibold inline-flex items-center justify-center gap-2 active:scale-95 transition-transform"
            >
              <Compass size={16} /> {t("nav.experiences")}
            </Link>
            <button
              data-testid="mobile-bar-enquire"
              onClick={onEnquire}
              className="flex-1 rounded-full border border-gold/50 text-gold py-3 text-sm font-semibold inline-flex items-center justify-center gap-2 active:scale-95 transition-transform"
            >
              <Home size={16} /> {t("nav.enquire")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
